import { render, staticRenderFns } from "./PerseoDashboard.vue?vue&type=template&id=2bf837fb&scoped=true"
import script from "./PerseoDashboard.vue?vue&type=script&lang=js"
export * from "./PerseoDashboard.vue?vue&type=script&lang=js"
import style0 from "./PerseoDashboard.vue?vue&type=style&index=0&id=2bf837fb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf837fb",
  null
  
)

export default component.exports